import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_reference_material_lessons_path } from '@/modules/routes';

interface LessonResponse {
  id: number;
  programs: {
    full_title_with_edition: string;
    id: number;
  }[];
  titles_for_programs: {
    [id: number]: string;
  };
}

export const useReferenceMaterialLessons = (referenceMaterialId: number) => (
  useQuery({
    placeholderData: [],
    queryFn: () => (
      axios
        .get<{ data: LessonResponse[] }>(
          plato_api_reference_material_lessons_path(referenceMaterialId, { extra_attributes: ['titles_for_program'] }),
        )
        .then(res => res.data.data)
    ),
    queryKey: ['lessons', 'referenceMaterial', referenceMaterialId],
  })
);
